export default __webpack_public_path__ + "static/media/area.244b5c63.png";